<template>
  <div class="badgesList">
    <div class="top">
      <h1 class="title">Badges</h1>
    </div>
    <div class="badges">
      <!-- Show Premium Badge here if user is premium -->
      <Badge v-if="showPremiumBadge" :badge="getPremiumBadge" />
      <Badge v-for="(badge, x) in getBadgesToDisplay" :key="x" :badge="badge" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Badge from "../../../components/BadgeSystem/Badge";
import BadgeConstants from "../../../ELYX/Badges/BadgeConstants";
import { BadgeStore } from "../../../ELYX/ELYXStore";

export default {
  name: "BadgesList",
  props: {
    isPreview: {
      type: Boolean,
      default: false,
    },
    nrBadgesToShow: {
      type: Number,
      default: 9999,
    },
    isProfilePremium: {
      type: Boolean,
      default: false,
    },
    currentUserIsOwner: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Badge,
  },
  computed: {
    badges: () => BadgeStore.state.badges,

    getBadgesToDisplay() {
      if (this.isPreview) {
        /** Ensure a premium PROFILE only has a total of 3 badges in preview */
        if ((this.user.isUserPremium && this.currentUserIsOwn) || this.isProfilePremium) {
          return this.badges.slice(0, this.nrBadgesToShow - 1);
        }
        return this.badges.slice(0, this.nrBadgesToShow);
      }
      return this.badges;
    },

    showPremiumBadge() {
      if (this.currentUserIsOwner) {
        return this.user.isUserPremium;
      } else {
        return this.isProfilePremium;
      }
    },

    ...mapState({
      user: (state) => state.auth.user,
    }),

    getPremiumBadge() {
      return BadgeConstants.badges.find((badge) => badge.badgeNr === 8);
    },
  },
};
</script>
